import { NavigationItemParams } from '@store/App/LeftMenu';
import { store } from '@store';
import { authUserService } from '@store/AuthUser/services/authUserService';
import { tabsNavigationStore } from '@common/TabsNavigationPage';
import { useClinicsAccess } from '@modules/clinics/ui/ClinicsPage/hooks/useClinicsAccess';
import { isNonProdEnv } from '@utils/isNonProdEnv';

import { buildNavigationItems } from '../utils/buildNavigationItems';

interface Data {
    navigationItems: NavigationItemParams[];
    isOpen: boolean;
    isTable: boolean;
    isOpenAndTable: boolean;
    withPhoneWidget: boolean;
    withSupportWidget: boolean;
    isPhoneWidgetOpen: boolean;
    isMobile: boolean;
    disableOpen: boolean;
    toggleIsLeftMenuOpen(): void;
    closeMenu(): void;
    onLinkClick(): void;
    onSubItemTitleClick(): void;
    onLogoutClick(): void;
    onTogglePhoneWidgetToggle(): void;
}

export function useLeftMenu(): Data {
    const {
        app,
        app: { leftMenu },
        authUser,
        viewPort,
    } = store;
    const { hasAccess } = useClinicsAccess();

    const isOpen = leftMenu.isOpen;
    const isTable = viewPort.isTableSize;

    const navigationItems = buildNavigationItems({
        authUser,
        leftMenu,
        hasClinicsAccess: hasAccess,
        isNonProdEnv: isNonProdEnv(),
    });

    const toggleIsLeftMenuOpen = (): void => {
        leftMenu.toggleIsLeftMenuOpen();
    };

    const closeMenu = (): void => {
        if (isOpen) {
            leftMenu.toggleIsLeftMenuOpen();
        }
    };

    const onLinkClick = (): void => {
        tabsNavigationStore.navigationTabs.activeIndex = 0;
        closeMenu();
    };

    const onSubItemTitleClick = (): void => {
        if (!isOpen) {
            leftMenu.toggleIsLeftMenuOpen();
        }
    };

    const onLogoutClick = (): void => {
        authUserService.logout();
    };

    const onTogglePhoneWidgetToggle = (): void => {
        app.phoneWidget.isOpen = !app.phoneWidget.isOpen;
    };

    return {
        navigationItems,
        isOpen,
        isTable,
        isOpenAndTable: isOpen && isTable,
        withPhoneWidget: authUser.hasShortNumber,
        withSupportWidget: app.isSupportEnabled,
        isPhoneWidgetOpen: app.phoneWidget.isOpen,
        isMobile: viewPort.isMobileSize,
        disableOpen: leftMenu.disableOpen,
        toggleIsLeftMenuOpen,
        closeMenu,
        onLinkClick,
        onSubItemTitleClick,
        onLogoutClick,
        onTogglePhoneWidgetToggle,
    };
}
